import React, { useEffect, useState } from "react";
import Card from "components/card";
import { getContactInquiries, deleteInquiry } from "services/contacts";
import { useToast } from "components/Toast";
import { useNavigate, Link } from "react-router-dom";

const ContactIndex: React.FC = () => {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await getContactInquiries();
        setItems(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleDelete = async (id: number) => {
    if (!window.confirm("Delete inquiry?")) return;
    try {
      await deleteInquiry(id);
      setItems((prev) => prev.filter((i) => i.id !== id));
    } catch (err) {
      console.error(err);
      toast.showError("Failed to delete inquiry");
    }
  };

  return (
    <Card extra="w-full p-4">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900">Contact Inquiries</h2>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : items.length === 0 ? (
        <p className="text-gray-500">No inquiries.</p>
      ) : (
        <div className="space-y-2">
          {items.map((it) => (
            <div
              key={it.id}
              className="flex items-center justify-between rounded bg-white p-4 shadow dark:bg-navy-700 dark:shadow-none"
            >
              <div>
                <div className="font-semibold">
                  {it.name} &lt;{it.email}&gt;
                </div>
                <div className="text-sm text-gray-600 dark:text-gray-300">
                  {it.subject}
                </div>
              </div>
              <div className="space-x-3 text-sm">
                <button
                  onClick={() => navigate(`/admin/contact/${it.id}`)}
                  className="text-indigo-600"
                >
                  View
                </button>
                <button
                  onClick={() => handleDelete(it.id)}
                  className="text-red-600"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default ContactIndex;
// (removed duplicate placeholder)
